<template>
  <v-dialog :scrim="true" v-model="dialog" fullscreen>
    <template #activator="{ props }">
      <v-btn v-bind="props" color="primary"> Ajouter une pièce </v-btn>
    </template>

    <v-card>
      <v-toolbar>
        <v-btn icon="mdi-close" @click="closeDialog" />
        <v-toolbar-title>Add Inventory</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-autocomplete
          label="Spare Part"
          :items="availableSpareparts"
          item-title="displayName"
          v-model="selected"
          return-object
        />

        <v-text-field type="number" label="Quantity" v-model.number="quantity" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeDialog">Annuler</v-btn>
        <v-btn color="primary" @click="add">Ajouter</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { getAllSpareparts } from "@/utils/sparepart-api";
import { postInventoryItem } from "@/utils/vehicle-api";
import { ref, onMounted, computed, watch } from "vue";

const props = defineProps({
  vehicleId: Number,
  inventoryItems: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits(["added"]);

const dialog = ref(false);
const spareparts = ref([]);
const selected = ref(null);
const quantity = ref(1);

const resetForm = () => {
  selected.value = null;
  quantity.value = 1;
};

const closeDialog = () => {
  dialog.value = false;
  resetForm();
};

const availableSpareparts = computed(() => {
  const existingIds = new Set((props.inventoryItems || []).map((item) => item?.sparepartId));
  return spareparts.value.filter((part) => !existingIds.has(part?.id));
});

onMounted(async () => {
  try {
    spareparts.value = await getAllSpareparts();
  } catch (error) {
    // Ignore
  }
});

watch(dialog, (isOpen) => {
  if (isOpen) {
    resetForm();
  }
});

const add = async () => {
  if (!selected.value?.id) {
    return;
  }

  try {
    await postInventoryItem(props.vehicleId, {
      sparepartId: selected.value.id,
      quantity: quantity.value,
    });
  } catch (error) {
    // Ignore
  }

  emit("added", {
    sparepartId: selected.value.id,
    sparepartName: selected.value.name,
    sparepartFrenchName: selected.value.frenchName,
    quantity: quantity.value,
  });

  closeDialog();
};
</script>
